import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// components
import TermsAndConditions from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/TermsAndConditions';
import Button from '@/components/ui/buttons/Button';
import { ITextStyles } from '@/components/ui/content/Text';
import { Form } from 'react-final-form';
import FormSection from '@/components/forms/FormSection';
import SSOLoginButton from '@/components/landing-page-templates/ConfigurableLandingPage/LandingPageForms/SocialLoginSection/SSOLoginButton';
import GoogleLoginButton from '@/components/landing-page-templates/ConfigurableLandingPage/LandingPageForms/SocialLoginSection/GoogleLoginButton';
import FacebookLoginButton from '@/components/landing-page-templates/ConfigurableLandingPage/LandingPageForms/SocialLoginSection/FacebookLoginButton';
import LinkedInLoginButton from '@/components/landing-page-templates/ConfigurableLandingPage/LandingPageForms/SocialLoginSection/LinkedInLoginButton';
// images
// import ChevronRight from '@/public/images/chevron-right.svg';
// types
import { IButtonTypes } from '@/components/ui/buttons/Button/types';
import { SIGN_IN_FORM_FIELDS } from './config';
import api from '@/api';
// styles
import styles from './styles.module.scss';
// configurations
import { FACEBOOK_ENABLED } from '@/config';

const SignInForm = ({ initialValues = {}, onSuccess }) => {
  const dispatch = useDispatch();

  const handleFormSubmit = signInValues => {
    // Making this no-op for now
    // as we no longer support old org side
  };

  return (
    <div>
      <Form
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <FormSection
              formData={SIGN_IN_FORM_FIELDS}
              styleClass="signInNew"
            />
            <div className={styles.forgotPasswordContainer}>
              <a className={styles.forgotPasswordLink} href="/a/reset/request">
                Forgot your password?
              </a>
            </div>
            <Button
              loading={submitting}
              label="Sign In"
              type="submit"
              styleClass={IButtonTypes.NEW_SIGNIN_BUTTON}
              textStyle={ITextStyles.DEFAULT}
            />
            {/* NOTE - this is disabled for now until I have the backend for the signup page built. */}
            {/* <a className={styles.signUpLink} href="/a/signup">
              <div>First time?</div>
              <div className={styles.signUpLinkBoldText}>Create an account</div>
              <img src={ChevronRight} alt="" className={styles.signUpLinkArrow} />
            </a> */}
            <h6 className={styles.socialLoginText}> - or login with - </h6>
          </form>
        )}
      />
      <div className={styles.socialButtonContainer}>
        <SSOLoginButton />
        <GoogleLoginButton isAttendeeRegistration={false}/>
        {FACEBOOK_ENABLED && <FacebookLoginButton />}
        <LinkedInLoginButton />
      </div>
      {/* Terms and Conditions */}
      <TermsAndConditions />
    </div>
  );
};

export default SignInForm;
